<template>
  <div class="home_body">

    <div style="position: relative;width: 100%">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in list" :key="item.url">
          <img @click="lunbo(item)" :src="item.url">
        </van-swipe-item>
        <!--        <van-swipe-item>-->
        <!--          <img src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2034870996,3303762327&fm=26&gp=0.jpg">-->
        <!--        </van-swipe-item>-->
        <!--        <van-swipe-item>-->
        <!--          <img src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2034870996,3303762327&fm=26&gp=0.jpg">-->
        <!--        </van-swipe-item>-->
        <!--        <van-swipe-item>-->
        <!--          <img src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2034870996,3303762327&fm=26&gp=0.jpg">-->
        <!--        </van-swipe-item>-->
      </van-swipe>
      <div class="dingwei">
        <van-search shape="round" v-model="value" placeholder="请输入搜索关键词" input-align="center"/>
      </div>
    </div>

    <div class="kecheng">
      <div class="yanse"></div>
      <div class="tuijian">课程推荐</div>
    </div>

    <div class="clear"></div>

    <div class="kechengtu">
      <div class="neirong1" v-for="item in curricu" @click="xiangqing(item)">
        <div>
                    <img style="height: 95px;" :src="item.covermap">
          <div
            style="width: 100%;background: rgba(0,0,0,0.5);height: 95px;position: absolute;top: 0;border-radius: 0px">
            <div class="laoshi">老师：{{item.teacher}}</div>
          </div>
        </div>
        <div style="height: 70px">
          <div class="chaochu" style="margin-left: 10px;">{{item.titles}}</div>
          <div class="biaoqian" v-for="items in item.tag">
            <div>
              <van-tag type="success">{{items}}</van-tag>
            </div>
            <!--          <div>-->
            <!--            <van-tag type="success">暂无</van-tag>-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <van-tag type="success">1天</van-tag>-->
            <!--          </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>

    <!--    <div style=" text-align: center"><img style="border-radius: 500px;" src="../../static/online_video.png" width="90%" alt=""></div>-->

    <div class="clear"></div>

    <div class="gundong">
      <van-tabs v-model="moblue">
        <van-tab title="正在学习" name="a">
          <van-empty description="暂时没有视频，请加油努力！" v-if="this.lists==null || this.lists.length==0"/>
          <div class="wei" :style="index==0?'margin-top:20px':''" v-for="(item,index) in lists">
            <div class="tupian" style="position: relative">
              <img :src="item.covermap"/>
              <div
                style="width: 100%;background: rgba(0,0,0,0.5);height: 140px;position: absolute;top: 0;border-radius: 6px"></div>
            </div>
            <div class="miaoshu">
              <div class="miaoshu1">{{item.titles}}</div>
              <div class="miaoshu2">{{item.introduce}}</div>
            </div>
            <div class="jindu">
              <div class="shuzi">{{item.usercurrdatanum}}/{{item.currdatanum}}</div>
              <div class="tiao">
                <van-progress
                  :percentage="item.percentage"
                  pivot-color="#0AE0D8"
                  color="#0AE0D8"
                />
              </div>
              <div class="xuexi" @click="xuexi(item)">继续学习</div>
            </div>
          </div>

        </van-tab>
        <van-tab title="已完成" name="b">
          <van-empty description="暂时没有视频，请加油努力！" v-if="this.wancheng==null || this.wancheng.length==0"/>
          <div class="wei" :style="index==0?'margin-top:20px':''" v-for="(item,index) in wancheng">
            <div class="tupian" style="position: relative">
              <img :src="item.covermap"/>
              <div
                style="width: 100%;background: rgba(0,0,0,0.5);height: 140px;position: absolute;top: 0;border-radius: 6px">
              </div>
            </div>
            <div class="miaoshu">
              <div class="miaoshu1">{{item.titles}}</div>
              <div class="miaoshu2">{{item.introduce}}</div>
            </div>
            <div class="jindu">
              <div class="shuzi">{{item.usercurrdatanum}}/{{item.currdatanum}}</div>
              <div class="tiao">
                <van-progress
                  :percentage="100"
                  pivot-color="#0AE0D8"
                  color="#0AE0D8"
                />
              </div>
              <div class="xuexi" @click="xuexi(item)">继续学习</div>
            </div>
          </div>


        </van-tab>
      </van-tabs>


    </div>


  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        active: 0,
        value: '',
        moblue: 'a',
        isShowBack: false,
        list: [],
        curricu: [],
        lists: [],
        wancheng: [],
      }
    },
    created() {
      this.getdata()
      console.log(this.$store.state.token, 2222333)
    },
    methods: {
      lunbo(item) {

        if(item.types==2){
          this.$router.push({path: '/group', query: {id: item.gotourl}})
        }else{
          this.$router.push({path: '/bank', query: {id: item.gotourl}})
        }
      },
      //视频跳转
      xuexi(item) {
        this.$router.push({path: '/bank', query: {id: item.id, activeName: "b"}})
      },
      //详情
      xiangqing(item) {
        this.$router.push({path: '/bank', query: {id: item.id}})
      },
      getdata() {
        var that = this;

        this.myrequest({
          url: '/client/getindex.action',
          types: 'get',
          data: {
            // token:this.$store.state.token,
          },
          succ: (res) => {
            console.log("轮播",res);

            that.list = res.data.imglist
            that.curricu = res.data.curriculum
            that.lists = res.data.havacurr
            that.wancheng = res.data.overcurr
          },
          errs: (msg) => {
            console.log(msg);
          }
        })


      }

    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .home_body {
    width 100%;

    >>> .van-swipe__track {
      width 100% !important;
    }

    >>> .van-swipe-item {
      width 100% !important
    }

    >>> .my-swipe img {
      width 100% !important;
    }

    >>> .van-tabs__line {
      background-color #0AC1BA
      bottom 0px
    }

    /*>>>.van-field__left-icon {
      position absolute;
      left 25%;
      top 5px
    }*/

    >>> .van-tag--success {
      background-color #0AC1BA
    }

    .miaoshu {
      position absolute;
      top 20px;
      color #ffffff;
      left 5%;

      .miaoshu1 {
        font-weight bold;
        font-size 14px;
      }

      .miaoshu2 {
        margin-top 15px;
      }
    }

    .gundong {
      padding-bottom 50px;

      >>> .van-tabs__nav--line {
        padding 0 22%
      }
    }

    >>> .van-progress {
      height 10px;
    }

    .jindu {
      /*margin-bottom 20px;*/
      position absolute;
      bottom -20px;
      background-color #fafafa;
      width 100%;
      height 40px;
      border-radius 15px;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, .2);

      .shuzi {
        width 15%;
        float left;
        line-height 40px;
        color #333333;
        font-weight bold;
        font-size 14px;
        text-align center
      }

      .tiao {
        width 58%;
        float left;
        line-height 40px;
        margin-top 16px;
      }

      .xuexi {
        width 20%;
        float right;
        line-height 24px;
        color #ffffff;
        text-align center
        background-color #29D8D1;
        border-radius 20px;
        margin-right 10px;
        margin-top 8px;
      }
    }

    .kechengtu {
      width 100%;
      margin-top 10px
      overflow-x scroll
      padding-bottom 10px
      height 100%;
      white-space: nowrap;
    }

    .biaoqian {
      div {
        float right;
        margin-right: 10px;
        margin-top 5px;

        >>> .van-tag {
          border-radius 6px
        }
      }
    }

    .laoshi {
      position absolute;
      right 10px;
      font-size 8pt !important
      bottom 10px;
      color #ffffff !important;
    }

    .kechengtu::-webkit-scrollbar {
      display: none
    }

    .neirong1 {
      position relative;
      overflow hidden
      display: inline-block;
      border-radius 5px;
      padding-bottom 10px
      width 45%;
      background-color #fafafa;
      height auto;
      /*float left;*/
      /*text-align center*/
      margin-left 2%;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
      margin-right 13px;

      .chaochu {
        white-space: nowrap; /*一行显示*/
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /*用...代替超出部分*/
        width 150px;
      }

      img {
        width 100%;
        /*border-radius 10px;*/
        /*box-shadow: 5px 5px 5px rgba(0,0,0,.5);*/
      }

      div {
        font-size 11pt
        color #333333
      }
    }

    .clear {
      clear: both;
    }

    .kecheng {
      width 90%;
      margin-left 5%
      margin-top 25px

      .yanse {
        background-color #0AC1BA;
        width 4px;
        height 20px;
        float left;
      }

      .tuijian {
        float left;
        margin-left 10px;
        color #333333;
        font-weight bold
        font-size 14px;
      }
    }

    >>> .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
      border none
    }

    >>> .van-search {
      padding 0px;
      border-radius 15px
    }

    .dingwei {
      position absolute;
      bottom -15px;
      left 5%;
      width 90%;
      z-index 999;

    }

    >>> .van-field__control::-webkit-input-placeholder { /* WebKit browsers */
      color: rgba(51, 51, 51, 0.8);
      font-size: 13px;
    }

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      text-align: center;
    }

    .my-swipe {
      img {
        width 375px;
        height 200px;
      }
    }

    >>> .van-swipe__indicators {
      bottom 25px
    }

    >>> .van-swipe-item {
      width 100% !important;
      height 200px !important;
    }

    .tupian {
      /*float left;*/
      width 100%;
      /*margin-right 10px;*/
      /*margin-bottom 10px;*/
      margin auto

      img {
        width 100%;
        height 140px;
        border-radius 10px;
      }
    }

    .neirong {
      float left;
      width 40%;

      div {
        color #ccc;
        margin-top 5px;
      }
    }

    .wei {
      width 90%;
      margin-left 5%
      margin-top 35px
      position relative
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/home.vue